import React from 'react';
import styled from 'styled-components';
import { Body5 } from '@ui';
import LoadingSpinner from './LoadingSpinner';
import { colorPalette } from '@theme';

const Error = styled.div`
  padding-bottom: 8px;

  * {
    color: ${colorPalette.secondary.red};
  }
`;
const Submitting = styled.div`
  padding-bottom: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ LeftAligned }) => (LeftAligned ? 'flex-start' : 'center')};
`;
const SubmittingIcon = styled.div`
  margin-right: 8px;

  div,
  svg {
    margin: 0;
    height: 18px;
    width: 18px;
  }
`;

export const FormState = ({ isSubmitting, error, text, leftAligned }) => {
  return (
    <div>
      {error && (
        <Error>
          <Body5>{error}</Body5>
        </Error>
      )}
      {isSubmitting && (
        <Submitting LeftAligned={leftAligned}>
          <SubmittingIcon>
            <LoadingSpinner />
          </SubmittingIcon>
          <Body5>{text || 'Sending...'}</Body5>
        </Submitting>
      )}
    </div>
  );
};
